import classNames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';

import styles from './Tag.module.css';
import { TAG_COLORS } from './TAG_COLORS';
import { TAG_SIZES } from './TAG_SIZES';
import { TAG_VARIANTS } from './TAG_VARIANTS';

const colors: {[key: string]: string} = {
    [TAG_COLORS.YELLOW]: 'bg-yellow-500',
    [TAG_COLORS.WHITE]: 'bg-navy-50',
    [TAG_COLORS.VIOLET]: 'bg-violet-500',
    [TAG_COLORS.TEAL]: 'bg-teal-200',
    [TAG_COLORS.GRAY]: 'bg-navy-200',
};

export type ITagProps = IQATestableProps & {
    children: ReactNode;
    color: TAG_COLORS;
    size: TAG_SIZES;
    variant: TAG_VARIANTS;
};

export function OzTag (props: ITagProps): ReactElement {
    const {
        'data-testid': dataTestId = '',
        children,
        color,
        size,
        variant,
    }: ITagProps = props;

    const tagClassNames: string = classNames({
        'font-gellix font-bold w-auto inline-block whitespace-nowrap': true,
        [colors[color]]: true,
        [`text-sm ${styles.small}`]: size === TAG_SIZES.SMALL,
        [`text-base ${styles.large}`]: size === TAG_SIZES.LARGE,
        [styles.square]: variant === TAG_VARIANTS.SQUARE,
        [styles.rounded]: variant === TAG_VARIANTS.ROUNDED,
    });

    return (
        <div data-testid={dataTestId} className={tagClassNames}>{children}</div>
    );
}
